const toHex = (buffer: ArrayBuffer) =>
  [...new Uint8Array(buffer)].map((byte) => byte.toString(16).padStart(2, "0")).join("");

export const createSubmissionToken = () => {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);

  let binary = "";
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
};

export const createSubmissionTokenPair = async () => {
  const token = createSubmissionToken();
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(token));

  return {
    token,
    tokenHash: toHex(digest),
  };
};